export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteSelfProfileDialog.json?hash=b184d47d46fba5797df3e6ea1c68b129";